import {
  add,
  addCircleOutline,
  alert,
  alertCircle,
  alertCircleOutline,
  arrowBack,
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  arrowRedoCircleOutline,
  arrowUndo,
  attach,
  backspaceOutline,
  bulbOutline,
  businessOutline,
  calendar,
  calendarOutline,
  caretDown,
  chatboxEllipses,
  chatboxEllipsesOutline,
  chatbubbleEllipsesOutline,
  chatbubblesOutline,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDone,
  checkmarkOutline,
  chevronBack,
  chevronDown,
  chevronForward,
  chevronUp,
  close,
  closeCircleOutline,
  closeOutline,
  cloudDone,
  cloudDoneOutline,
  cloudOffline,
  cloudOfflineOutline,
  cloudUpload,
  cloudUploadOutline,
  cogOutline,
  contrastOutline,
  create,
  createOutline,
  documentTextOutline,
  duplicateOutline,
  ellipse,
  enterOutline,
  exitOutline,
  eye,
  eyeOffOutline,
  eyeOutline,
  fileTrayFull,
  fileTrayFullOutline,
  flash,
  funnel,
  funnelOutline,
  grid,
  gridOutline,
  heart,
  heartDislikeOutline,
  hourglassOutline,
  keyOutline,
  keypadOutline,
  lockClosedOutline,
  lockOpenOutline,
  paperPlaneOutline,
  chevronBackOutline,
  locationOutline,
  logIn,
  logInOutline,
  logoApple,
  logoGooglePlaystore,
  logOutOutline,
  mail,
  mailOpenOutline,
  mailOutline,
  mailUnreadOutline,
  megaphone,
  moonOutline,
  newspaper,
  newspaperOutline,
  openOutline,
  people,
  peopleOutline,
  personCircle,
  personCircleOutline,
  personOutline,
  pieChart,
  pinOutline,
  qrCode,
  qrCodeOutline,
  radioButtonOnOutline,
  readerOutline,
  refreshCircleOutline,
  refreshOutline,
  remove,
  removeOutline,
  search,
  searchOutline,
  send,
  shieldCheckmarkOutline,
  statsChart,
  statsChartOutline,
  swapHorizontal,
  swapVertical,
  time,
  timeOutline,
  timerOutline,
  trashOutline,
} from 'ionicons/icons';

export const iconList = {
  add,
  addCircleOutline,
  alert,
  alertCircle,
  alertCircleOutline,
  arrowBack,
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  arrowRedoCircleOutline,
  arrowUndo,
  attach,
  backspaceOutline,
  bulbOutline,
  businessOutline,
  calendar,
  calendarOutline,
  caretDown,
  chatboxEllipses,
  chatboxEllipsesOutline,
  chatbubbleEllipsesOutline,
  chatbubblesOutline,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDone,
  checkmarkOutline,
  chevronBack,
  chevronDown,
  chevronForward,
  chevronUp,
  close,
  closeCircleOutline,
  closeOutline,
  cloudDone,
  cloudDoneOutline,
  cloudOffline,
  cloudOfflineOutline,
  cloudUpload,
  cloudUploadOutline,
  cogOutline,
  contrastOutline,
  create,
  createOutline,
  documentTextOutline,
  duplicateOutline,
  ellipse,
  enterOutline,
  exitOutline,
  eye,
  eyeOffOutline,
  eyeOutline,
  fileTrayFull,
  fileTrayFullOutline,
  flash,
  funnel,
  funnelOutline,
  grid,
  gridOutline,
  heart,
  heartDislikeOutline,
  hourglassOutline,
  keyOutline,
  keypadOutline,
  lockClosedOutline,
  lockOpenOutline,
  paperPlaneOutline,
  chevronBackOutline,
  locationOutline,
  logIn,
  logInOutline,
  logoApple,
  logoGooglePlaystore,
  logOutOutline,
  mail,
  mailOpenOutline,
  mailOutline,
  mailUnreadOutline,
  megaphone,
  moonOutline,
  newspaper,
  newspaperOutline,
  openOutline,
  people,
  peopleOutline,
  personCircle,
  personCircleOutline,
  personOutline,
  pieChart,
  pinOutline,
  qrCode,
  qrCodeOutline,
  radioButtonOnOutline,
  readerOutline,
  refreshCircleOutline,
  refreshOutline,
  remove,
  removeOutline,
  search,
  searchOutline,
  send,
  shieldCheckmarkOutline,
  statsChart,
  statsChartOutline,
  swapHorizontal,
  swapVertical,
  time,
  timeOutline,
  timerOutline,
  trashOutline,
  // Note: if you need to use an icon, add it here...
};
